import type { FlexProps} from '@chakra-ui/react'
import { Box, Flex, Text } from '@chakra-ui/react'
import type { MouseEventHandler } from 'react'

import { ChevronRight } from '@/icons'

import { icons } from './icons'
import { cellBorderColor } from './OfferCellWrapper'

export const SectionTitle = ({
  label,
  icon,
  isOpened = false,
  bg,
  onClick,
  children,
  ...rest
}: {
  label?: React.ReactNode | string
  icon?: keyof typeof icons | ''
  isOpened?: boolean
  bg?: string
  onClick?: MouseEventHandler<HTMLDivElement>,
  children?: React.ReactNode
} & FlexProps) => {
  const isExpandable = !!onClick

  return (
    <Flex
      onClick={onClick && onClick}
      {...rest}
      sx={{
        alignItems: 'center',
        gap: 2,
        p: 2,
        bg: bg || isExpandable ? 'gray.100' : 'gray.50',
        cursor: isExpandable ? 'pointer' : 'default',
        _hover: isExpandable ? { bg: 'gray.200' } : {},
        borderBottom: '1px solid',
        borderColor: cellBorderColor,
        ...rest.sx,
      }}
    >
      {isExpandable && <Box
        sx={{
          h: 5,
          transform: isOpened ? 'rotate(90deg)' : '',
          transformOrigin: 'center center',
          visibility: isExpandable ? 'visible' : 'hidden',
        }}
      >
        <ChevronRight width={3} height={3} />
      </Box>}

      {icon && icons[icon]}

      {label && (
        <Text sx={{ lineHeight: 5, fontWeight: 'medium', whiteSpace: 'nowrap' }}>{label}</Text>
      )}

      {children}
    </Flex>
  )
}
